import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { useResponsive } from 'src/hooks/use-responsive';

import { NAV, HEADER } from './config-layout';

// ----------------------------------------------------------------------

export default function Main({ children, sx, ...other }) {
  const lgUp = useResponsive('up', 'xl');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        py: `${HEADER.H_MOBILE + HEADER.SPACING}px`,
        ...(lgUp && {
          // px: 2,
          pt: `${HEADER.H_DESKTOP + HEADER.SPACING}px`,
          pb: 0,
          width: `calc(100% - ${NAV.WIDTH}px)`,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
